import { type FC } from 'react';
import { type ModalProps } from '~/modal/modalType.enum';
import { SettingsModalComponent } from '../settingsModal/settingsModal.component';
import {
  type ChangeableSettingRow,
  type SettingColumn, type SettingRow,
} from '../settingsTable/settingsTable.types';

type SettingsModalWithSpreadsheetSelectProps = ModalProps<{
  title: string;
  settingRows: SettingRow[];
  settingColumns: SettingColumn[];
  onSettingRowChange: (rowIndex: number, newRow: ChangeableSettingRow) => void;
  isLoading: boolean;
  spreadsheetIds: number[];
  currentSelectedSpreadsheetId: number | null;
  onSelectedSpreadsheetIdChange: (spreadsheetId: number) => void;
}>;

export const SettingsModalWithSpreadsheetSelectComponent: FC<SettingsModalWithSpreadsheetSelectProps> = (props) => {
  return (
    <SettingsModalComponent
      caption={props.title}
      isOpen={props.isOpen}
      onClose={props.onClose}
      settingColumns={props.settingColumns}
      settingRows={props.settingRows}
      onChange={props.onSettingRowChange}
      onSubmit={props.onClose}
      isLoading={props.isLoading}
      customSaveButton={null}
    />
  );
};
